import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';

export function CheckResults({ result }) {
  if (!result) return null;
  if (result.error) return <p className="text-sm text-red-300" data-testid="checker-error">{result.error}</p>;
  return (
    <div className="space-y-3" data-testid="checker-results">
      <div className={`rounded-xl border px-4 py-3 text-sm font-semibold ${result.valid ? 'border-emerald-500/40 bg-emerald-500/10 text-emerald-200' : 'border-red-500/40 bg-red-500/10 text-red-200'}`} data-testid="checker-verdict">
        {result.valid ? 'All seven rules pass.' : `Refuse. First failing rule: ${result.failedRule}.`}
        {result.expected && <span className="ml-2 font-normal text-gray-300" data-testid="checker-expected">Example expects {result.expected.valid ? 'pass' : `fail on ${result.expected.failedRule}`}: {result.matches ? 'match' : 'MISMATCH'}.</span>}
      </div>
      <ol className="space-y-2">
        {result.rules.map((r, i) => (
          <li key={r.id} className="flex items-start gap-3 rounded-lg border border-white/10 bg-white/[0.02] px-4 py-3" data-testid={`checker-rule-${r.id}`}>
            {r.ok ? <CheckCircle2 className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" /> : <XCircle className="w-4 h-4 text-red-400 mt-0.5 shrink-0" />}
            <div className="min-w-0">
              <div className="text-sm text-white">{i + 1}. {r.label} <span className="text-xs text-gray-500" data-testid={`checker-rule-${r.id}-status`}>{r.ok ? 'pass' : 'fail'}</span></div>
              <div className="text-xs text-gray-400 font-mono break-all">{r.detail}</div>
            </div>
          </li>
        ))}
      </ol>
      <p className="text-[11px] text-gray-500 font-mono break-all" data-testid="checker-digest">Receipt digest: {result.digest}</p>
    </div>
  );
}
